export default __webpack_public_path__ + "static/media/x.8d6f221c.svg";